module.exports = __webpack_public_path__ + "img/debian.dc5802d0.svg";